import { render, staticRenderFns } from "./SuggestedBooks.vue?vue&type=template&id=8f521806"
import script from "./SuggestedBooks.vue?vue&type=script&lang=js"
export * from "./SuggestedBooks.vue?vue&type=script&lang=js"
import style0 from "./SuggestedBooks.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports